/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ConvocationResignationProcess model module.
 * @module model/ConvocationResignationProcess
 * @version 1.0.0
 */
class ConvocationResignationProcess {
    /**
     * Constructs a new <code>ConvocationResignationProcess</code>.
     * @alias module:model/ConvocationResignationProcess
     */
    constructor() { 
        
        ConvocationResignationProcess.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConvocationResignationProcess</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConvocationResignationProcess} obj Optional instance to populate.
     * @return {module:model/ConvocationResignationProcess} The populated <code>ConvocationResignationProcess</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConvocationResignationProcess();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('is_extraordinary')) {
                obj['is_extraordinary'] = ApiClient.convertToType(data['is_extraordinary'], 'Boolean');
            }
            if (data.hasOwnProperty('end_date')) {
                obj['end_date'] = ApiClient.convertToType(data['end_date'], 'String');
            }
        }
        return obj;
    }


}

/**
 * The SIS process id.
 * @member {Number} id
 */
ConvocationResignationProcess.prototype['id'] = undefined;

/**
 * The internal process code.
 * @member {String} code
 */
ConvocationResignationProcess.prototype['code'] = undefined;

/**
 * Whether the process is only for extraordinary convocation resignations.
 * @member {Boolean} is_extraordinary
 */
ConvocationResignationProcess.prototype['is_extraordinary'] = undefined;

/**
 * The date until when the process will be active.
 * @member {String} end_date
 */
ConvocationResignationProcess.prototype['end_date'] = undefined;






export default ConvocationResignationProcess;

